module.exports = __webpack_public_path__ + "static/media/lahav.deffe9ed.jpg";